import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GenericModal } from '@org/ui';
import { JourneyMultiStepForm } from '../../app/components/journey/journey-multi-step-form';
import { trpc } from '@org/clients/school';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/journeys/new')({
  component: JourneyCreateRoute,
});

function JourneyCreateRoute() {
  const navigate = useNavigate({ from: '/journeys/new' });
  const utils = trpc.useUtils();
  const { t } = useTranslation('admin');

  const handleClose = () => {
    navigate({ to: '/journeys', replace: true });
  };

  const handleSubmit = async () => {
    await utils.journeys.list.invalidate();
    handleClose();
  };

  return (
    <GenericModal
      show
      onClose={handleClose}
      title={t('journeys.list.modal.createTitle')}
      size="xl"
      centered
      body={
        <JourneyMultiStepForm
          defaultValues={{}}
          onSubmit={handleSubmit}
          onClose={handleClose}
          isEditing={false}
        />
      }
      footer={<></>}
    />
  );
}


